import {useMutation} from "@tanstack/react-query";
import {ErrorKey, getErrorKey} from "@/config/apiErrorKeys.ts";
import {ApiConfig} from "@/config/api.config.ts";
import axios, {AxiosError} from "axios";
import {ProblemDetails} from "@/@types/base.types.ts";
import {LoginResponseDto} from "@/@types/auth.types.ts";

type Props = {
    onSuccess?: (result: LoginResponseDto) => void;
    onError?: (error: ErrorKey) => void;
}

type DoTwoFactorLoginProps = {
    code: string;
    token: string;
}

export const useTwoFactorLoginApi = ({onSuccess, onError}: Props) => {
    const {mutateAsync: doTwoFactorLogin, isPending: isDoTwoFactorLogin} = useMutation({
        mutationFn: async ({code, token}: DoTwoFactorLoginProps) => {
            // Unauthenticated step (the user has no session yet), so use a clean axios instance to avoid
            // the global 401 interceptor signing the user out on an invalid/expired code.
            const axiosInstance = axios.create({baseURL: ApiConfig.currentUrls.api});
            const response = await axiosInstance.post<LoginResponseDto>(ApiConfig.queries.auth.twoFactorLogin.endpoint, {
                code,
                token
            });
            return response.data;
        },
        onSuccess: (data) => {
            onSuccess?.(data);
        },
        onError: (error: AxiosError<ProblemDetails>) => {
            onError?.(getErrorKey(error));
        }
    })

    return {
        doTwoFactorLogin,
        isDoTwoFactorLogin
    }
}